var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "600px",
        "content-class": "configuration-dialog",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "info",
                    attrs: { disabled: !_vm.aquariusSynchronizer },
                  },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("refresh")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v("Sync Aquarius Stations.."),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: { title: "Station synchronization" },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      }),
      _vm._v(" "),
      _vm._v(" "),
      _vm.dialog
        ? [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { attrs: { flat: "", dark: "" } },
                  [
                    _c(
                      "v-toolbar",
                      { attrs: { dark: "", color: "primary" } },
                      [
                        _c("v-toolbar-title", [
                          _vm._v("Sync Aquarius Stations"),
                        ]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", dark: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-alert",
                      {
                        staticClass: "ma-0 pa-2",
                        attrs: {
                          color: "info",
                          icon: "info",
                          outline: "",
                          value: _vm.loading.sync,
                        },
                      },
                      [
                        _c("div", { staticClass: "primary--text" }, [
                          _vm._v(
                            "\n            The sync is currently running and can take between 10-20 minutes. You may close\n            your browser or navigate to a different page.\n          "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      { staticClass: "py-3" },
                      [
                        _c("p", [
                          _vm._v(
                            "\n            Synchronize the Aquarius stations to fetch the latest station and time series updates. These will be\n            mapped to all tenants, but by default new entries will be disabled.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-radio-group",
                          {
                            attrs: { row: "" },
                            model: {
                              value: _vm.syncOptions.aquariusServerType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.syncOptions,
                                  "aquariusServerType",
                                  $$v
                                )
                              },
                              expression: "syncOptions.aquariusServerType",
                            },
                          },
                          _vm._l(
                            _vm.AQUARIUS_SERVER_TYPES,
                            function (serverType, index) {
                              return _c("v-radio", {
                                key: `serverType-${index}`,
                                attrs: {
                                  color: "primary",
                                  label: serverType.name,
                                  value: serverType.value,
                                },
                              })
                            }
                          ),
                          1
                        ),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "mt-2",
                          attrs: {
                            color: "primary",
                            label: "Sync Station metadata",
                            "persistent-hint": "",
                            hint: "Takes approximately 5 minutes longer.",
                          },
                          model: {
                            value: _vm.syncOptions.syncStationMetadata,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.syncOptions,
                                "syncStationMetadata",
                                $$v
                              )
                            },
                            expression: "syncOptions.syncStationMetadata",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "mt-2",
                          attrs: {
                            color: "primary",
                            label: "Sync Time Series",
                            "persistent-hint": "",
                            hint: "Takes approximately 10 minutes longer.",
                          },
                          model: {
                            value: _vm.syncOptions.syncTimeSeries,
                            callback: function ($$v) {
                              _vm.$set(_vm.syncOptions, "syncTimeSeries", $$v)
                            },
                            expression: "syncOptions.syncTimeSeries",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "mt-2",
                          attrs: {
                            color: "error",
                            label: "Force",
                            "persistent-hint": "",
                            hint: "If a sync is already running, it will be restarted.",
                          },
                          model: {
                            value: _vm.syncOptions.forceIfRunning,
                            callback: function ($$v) {
                              _vm.$set(_vm.syncOptions, "forceIfRunning", $$v)
                            },
                            expression: "syncOptions.forceIfRunning",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { staticStyle: { "border-top": "1px solid #dddddd" } },
                  [
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _vm.loading.sync,
                              color: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.syncAquariusStations()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("sync"),
                            ]),
                            _vm._v("Sync\n          "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "secondary", outline: "" },
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v("Close")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }